import { useState } from 'react'

import {
  EnableSpecialHoursRegularHoursCompensationDocument,
  EnableSpecialHoursRegularHoursCompensationMutation,
  EnableSpecialHoursRegularHoursCompensationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useEnableSpecialHoursRegularHoursCompensation = () => {
  const [enableSpecialHoursRegularHoursCompensation, { loading }] = useMutation(
    EnableSpecialHoursRegularHoursCompensationDocument,
    {
      extractorFn: (data: EnableSpecialHoursRegularHoursCompensationMutation) =>
        data.attendanceMutations.updateAttendanceEmployeesSetting,
      update(cache, result) {
        const errors =
          result?.data?.attendanceMutations?.updateAttendanceEmployeesSetting?.errors ?? []

        const employeesSettingId =
          result?.data?.attendanceMutations?.updateAttendanceEmployeesSetting?.employeesSetting?.id

        if (errors.length === 0 && employeesSettingId) {
          cache.modify({
            id: `AttendanceEmployeesSetting:${employeesSettingId}`,
            fields: {
              specialHoursRegularHoursCompensation() {
                return true
              },
            },
          })
        }
      },
    }
  )

  const [errors, setErrors] = useState({})

  const enable = async (variables: EnableSpecialHoursRegularHoursCompensationMutationVariables) => {
    const result = await enableSpecialHoursRegularHoursCompensation({
      variables,
    })

    const handled = handleResult(result, (errs) => {
      setErrors(errs)
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: Object.values(errors).join(',') ?? i18n.t('errors.generic_error'),
      })
    }
  }

  return {
    loading,
    enable,
    errors,
  }
}
